// src/components/Header.js
import { NavLink } from 'react-router-dom';

const navClass = ({ isActive }) =>
  isActive
    ? "text-orange-600 border-b-2 border-orange-600"
    : "text-black hover:text-orange-600 transition-colors";

const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/projects", label: "Projects" },
  // Uncomment to re-enable the Other page:
  // { to: "/other", label: "Other" },
];

function Header() {
  return (
    <nav className="flex gap-6 font-mono font-bold uppercase tracking-widest">
      {NAV_LINKS.map(({ to, label }) => (
        <NavLink key={to} to={to} className={navClass}>
          {label}
        </NavLink>
      ))}
    </nav>
  );
}

export default Header;